module.exports = __webpack_public_path__ + "static/img/img5.27b0e152.png";